import { useMemo } from "react";

/**
 * Hook to detect if the current domain is the production domain
 * @returns {boolean} true if current domain is guildglory.digital
 */
export function useIsProductionDomain() {
  const isProduction = useMemo(() => {
    if (typeof window === "undefined") return false;

    const hostname = window.location.hostname;

    // Check if it's the production domain
    return (
      hostname === "guildglory.digital" || hostname === "www.guildglory.digital"
    );
  }, []);

  return isProduction;
}

/**
 * Hook to get current environment based on domain
 * @returns {'production' | 'staging' | 'local'} current environment
 */
export function useEnvironment() {
  const environment = useMemo(() => {
    if (typeof window === "undefined") return "local";

    const hostname = window.location.hostname;

    if (
      hostname === "guildglory.digital" ||
      hostname === "www.guildglory.digital"
    ) {
      return "production";
    }

    if (hostname === "guildglory.vercel.app") {
      return "staging";
    }

    return "local";
  }, []);

  return environment;
}
